
export { default as useImageSlider } from "./src/hooks/useImageSlider"